import { defineComponent as i, ref as p, computed as r, openBlock as f, createElementBlock as y, normalizeClass as t, createElementVNode as s, renderSlot as u } from "vue";
import { _ as c } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var o = /* @__PURE__ */ ((e) => (e.Input = "input", e.Toggle = "toggle", e.Group = "group", e.MenuItem = "menu-item", e))(o || {});
const g = [
  // Layout
  "layout-row justify-between",
  // Spacing
  "gap-sm"
], m = {
  [o.Input]: [
    // Typography
    "typography-caption-regular",
    // Theme
    "theme-foreground-outline",
    "dark:theme-foreground-outline-dark"
  ],
  [o.Toggle]: [
    // Typography
    "typography-body-2-regular",
    // Theme
    "theme-foreground-default",
    "dark:theme-foreground-default-dark"
  ],
  [o.Group]: [
    // Typography
    "typography-body-2-regular",
    // Theme
    "theme-foreground-default",
    "dark:theme-foreground-default-dark",
    // Theme (invalid)
    "invalid:theme-foreground-error",
    "dark:invalid:theme-foreground-error-dark"
  ],
  [o.MenuItem]: [
    // Typography
    "typography-body-2-regular",
    // Typography (selected)
    "selected:typography-body-2-semibold",
    // Theme
    "theme-foreground-default",
    "dark:theme-foreground-default-dark"
  ]
}, h = [
  // Interactivity
  "interactivity-default",
  // Interactivity (read-only)
  "read-only:interactivity-none",
  // Content (required)
  'required:after:content-["*"]'
], b = [
  // Layout
  "layout-inline-row empty:hidden",
  // Typography
  "whitespace-nowrap"
], v = i({
  name: "OrLabel",
  props: {
    controlId: {
      type: String,
      default: void 0
    },
    variant: {
      type: String,
      default: () => o.Input
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    }
  },
  expose: [
    "root"
  ],
  setup(e) {
    const d = p(), a = r(() => [
      "or-label-v3",
      ...g,
      ...m[e.variant]
    ]), n = r(() => [
      ...h
    ]), l = r(() => [
      ...b
    ]);
    return {
      root: d,
      rootStyles: a,
      contentStyles: n,
      addonStyles: l
    };
  }
}), k = ["invalid", "selected", "disabled"], S = ["for", "required", "disabled", "readonly"];
function B(e, d, a, n, l, I) {
  return f(), y("div", {
    ref: "root",
    class: t(e.rootStyles),
    invalid: e.invalid,
    selected: e.selected,
    disabled: e.disabled
  }, [
    s("label", {
      class: t(e.contentStyles),
      for: e.controlId,
      required: e.required,
      disabled: e.disabled,
      readonly: e.readonly
    }, [
      u(e.$slots, "default")
    ], 10, S),
    s("div", {
      class: t(e.addonStyles)
    }, [
      u(e.$slots, "addon")
    ], 2)
  ], 10, k);
}
const w = /* @__PURE__ */ c(v, [["render", B]]);
export {
  o as L,
  w as O
};
//# sourceMappingURL=OrLabel-DssheqEn.mjs.map
